import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var TrendingDown = createReactComponent("TrendingDown", ["svg", defaultAttributes, [["polyline", {
  points: "23 18 13.5 8.5 8.5 13.5 1 6",
  key: "1gaxlq"
}], ["polyline", {
  points: "17 18 23 18 23 12",
  key: "vfsgt2"
}]]]);
export default TrendingDown;